import { useCallback, useState } from 'react';
import { isFeatureFlagEnabled, setFeatureFlag } from './featureFlagStore';
import type { FLAG } from './flags';

export function useFeatureFlagRW(flag: FLAG) {
  const [flagState] = useState(() => isFeatureFlagEnabled(flag));

  return [
    flagState,
    useCallback(() => {
      setFeatureFlag(flag, !flagState);
    }, [flag, flagState])
  ] as const;
}

export function useFeatureFlag(flag: FLAG) {
  const [flagState] = useFeatureFlagRW(flag);

  return flagState;
}
